import type { ShoppingCart } from '@optionway/models';

interface SearchPrebookStore {
  result?: ShoppingCart;
}

export const useSearchPrebookStore = defineStore('search-prebook', {
  state: (): SearchPrebookStore => ({
    result: undefined,
  }),
  actions: {
    applyPrebook(result: ShoppingCart) {
      this.result = result;
      useSelectedOfferStore().$reset();
      useLuggagesStore().repriceSelectedBags();
    },
  },
});
